'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _set = require('babel-runtime/core-js/set');

var _set2 = _interopRequireDefault(_set);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _log = require('../utility/log');

var _log2 = _interopRequireDefault(_log);

var _PluginState = require('../PluginState');

var _PluginState2 = _interopRequireDefault(_PluginState);

var _Plugin = require('../Plugin');

var _Plugin2 = _interopRequireDefault(_Plugin);

var _Framework = require('./Framework');

var _Framework2 = _interopRequireDefault(_Framework);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 为解析成功、初始状态为active的插件进行启动操作
 * 
 * @ignore
 * @export
 * @class PluginStarter
 */
var PluginStarter = function () {
    /**
     * 创建一个插件启动器
     * 
     * @ignore
     * @param {Framework} framework 
     * @param {Map.<string, Plugin>} pluginsMap 
     * @memberof PluginStarter
     */
    function PluginStarter(framework, pluginsMap) {
        (0, _classCallCheck3.default)(this, PluginStarter);

        this.framework = framework;
        this.pluginsMap = pluginsMap;
        /**
         * @type {number[]}
         */
        this.startLevels = [];
        /**
         * @type {Map.<number, Set.<Plugin>>}
         */
        this.startLevelPluginsMap = new _map2.default();

        this.dispose = this.dispose.bind(this);
        this.buildWithStartLevel = this.buildWithStartLevel.bind(this);
        this.startPlugins = this.startPlugins.bind(this);
        this.startPluginInternal = this.startPluginInternal.bind(this);
        this.stopPlugins = this.stopPlugins.bind(this);

        this.buildWithStartLevel();
    }

    /**
     * 清理资源
     * 
     * @memberof PluginStarter
     */


    (0, _createClass3.default)(PluginStarter, [{
        key: 'dispose',
        value: function dispose() {
            this.pluginsMap = null;
            this.startLevels = [];
            this.startLevelPluginsMap.clear();
        }

        /**
         * 按照启动级别进行排序，将启动级别按照从小到大排列到startLevels，并将各个级别的插件组织到startLevelPluginsMap中，
         * 这个 map 的 value 是插件集合，插件使用id的字母排序。
         * 
         * @memberof PluginStarter
         */

    }, {
        key: 'buildWithStartLevel',
        value: function buildWithStartLevel() {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(this.pluginsMap), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var pair = _step.value;

                    var plugin = pair[1];
                    var startLevel = plugin.pluginConfiguration.startLevel;

                    if (!this.startLevelPluginsMap.has(startLevel)) {
                        this.startLevelPluginsMap.set(startLevel, []);
                        this.startLevels.push(startLevel);
                    }

                    this.startLevelPluginsMap.get(startLevel).push(plugin);
                }

                // Sort by startLevel
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            this.startLevels.sort(function (a, b) {
                return a - b;
            });

            // Sort by id
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)(this.startLevelPluginsMap), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var _pair = _step2.value;

                    var plugins = _pair[1];
                    plugins.sort(function (a, b) {
                        if (a.id.length == b.id.length) {
                            return a.id.localeCompare(b.id);
                        } else {
                            return a.id.length - b.id.length;
                        }
                    });
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }

        /**
         * 启动插件。插件启动顺序描述如下。<br/>
         * （1）按照启动级别进行分组排序，启动级别越小，越早启动；
         * （2）启动一个插件时，按照依赖关系优先处理，依赖的顶端先启动，依次进行启动。
         * 
         * @memberof PluginStarter
         */

    }, {
        key: 'startPlugins',
        value: function startPlugins() {
            _log2.default.logger.info('Starting the plugins with active initializedState.');
            var failedToStartedPlugins = new _set2.default();
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = (0, _getIterator3.default)(this.startLevels), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var startLevel = _step3.value;

                    var startingPlugins = new _set2.default();
                    var plugins = this.startLevelPluginsMap.get(startLevel);
                    var _iteratorNormalCompletion4 = true;
                    var _didIteratorError4 = false;
                    var _iteratorError4 = undefined;

                    try {
                        for (var _iterator4 = (0, _getIterator3.default)(plugins), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                            var plugin = _step4.value;

                            if (plugin.pluginConfiguration.initializedState !== _PluginState2.default.ACTIVE) {
                                continue;
                            }

                            this.startPlugin(plugin.id, startingPlugins, failedToStartedPlugins);
                        }
                    } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                _iterator4.return();
                            }
                        } finally {
                            if (_didIteratorError4) {
                                throw _iteratorError4;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            _log2.default.logger.info('The plugins with active initializedState are started.');
        }

        /**
         * 递归启动插件，在启动时，会先查找依赖的插件，执行依赖插件先启动
         * 
         * @param {string} id 
         * @param {Set.<string>} startingPlugins 正在启动的插件，避免循环依赖
         * @param {Set.<string>} failedToStartedPlugins 已经启动失败的插件，则不需要再次执行
         * @memberof PluginStarter
         */

    }, {
        key: 'startPlugin',
        value: function startPlugin(id, startingPlugins, failedToStartedPlugins) {
            startingPlugins.add(id);

            var plugin = this.pluginsMap.get(id);
            var dependencies = this.framework.pluginResolver.getDependencies(id);
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = (0, _getIterator3.default)(dependencies), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var dependency = _step5.value;

                    if (startingPlugins.has(dependency.id)) {
                        continue;
                    }

                    this.startPlugin(dependency.id, startingPlugins, failedToStartedPlugins);
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }

            this.startPluginInternal(failedToStartedPlugins, plugin);
        }

        /**
         * 如果插件没有在失败列表，则启动，否则忽略
         * 
         * @param {Plugin[]} failedToStartedPlugins 
         * @param {Plugin} plugin 
         * @memberof PluginStarter
         */

    }, {
        key: 'startPluginInternal',
        value: function startPluginInternal(failedToStartedPlugins, plugin) {
            if (failedToStartedPlugins.has(plugin.id)) {
                return;
            }
            try {
                plugin.start();
            } catch (error) {
                failedToStartedPlugins.add(plugin.id);
            }
        }

        /**
         * 停止插件
         * 
         * @memberof PluginStarter
         */

    }, {
        key: 'stopPlugins',
        value: function stopPlugins() {
            _log2.default.logger.info('Stopping all plugins.');
            for (var index = this.startLevels.length - 1; index >= 0; index--) {
                var startLevel = this.startLevels[index];

                var plugins = this.startLevelPluginsMap.get(startLevel);
                var _iteratorNormalCompletion6 = true;
                var _didIteratorError6 = false;
                var _iteratorError6 = undefined;

                try {
                    for (var _iterator6 = (0, _getIterator3.default)(plugins), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                        var plugin = _step6.value;

                        plugin.stop();
                    }
                } catch (err) {
                    _didIteratorError6 = true;
                    _iteratorError6 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion6 && _iterator6.return) {
                            _iterator6.return();
                        }
                    } finally {
                        if (_didIteratorError6) {
                            throw _iteratorError6;
                        }
                    }
                }
            }
            _log2.default.logger.info('All plugins are stopped.');
        }
    }]);
    return PluginStarter;
}();

exports.default = PluginStarter;
//# sourceMappingURL=PluginStarter.js.map